var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-search animated fadeIn roundedCard" },
    [
      _c("b-card", [
        _c("h1", { staticClass: "lbv-page-title" }, [
          _vm._v("\n      Assign Tenant to Device\n    "),
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "lbv-search-filter",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.assignTenant.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "leaklistFilters w-100" },
              [
                _c(
                  "b-row",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Device ID",
                              "label-for": "device-id",
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.searchDeviceID,
                                  expression: "searchDeviceID",
                                },
                              ],
                              staticClass: "form-control full-width",
                              attrs: {
                                id: "device-id",
                                type: "text",
                                placeholder: "LeakBot ID",
                              },
                              domProps: { value: _vm.searchDeviceID },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.searchDeviceID = $event.target.value
                                },
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Tenant",
                              "label-for": "select-tenant",
                            },
                          },
                          [
                            _c(
                              "b-form-select",
                              {
                                staticClass: "full-width",
                                attrs: { id: "select-tenant" },
                                model: {
                                  value: _vm.tenantSelection,
                                  callback: function ($$v) {
                                    _vm.tenantSelection = $$v
                                  },
                                  expression: "tenantSelection",
                                },
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v(
                                    "\n                  None\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.tenants, function (tenant) {
                                  return _c(
                                    "option",
                                    _vm._b(
                                      {
                                        domProps: { value: { id: tenant.id } },
                                        on: {
                                          option: function ($event) {
                                            return _vm.$emit(
                                              "option",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      },
                                      "option",
                                      _vm.$attrs,
                                      false
                                    ),
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(tenant.name) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "3" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "applyFilter rounded-pill",
                            attrs: {
                              id: "applyBtn",
                              variant: "primary",
                              type: "submit",
                            },
                          },
                          [_vm._v("\n              Assign\n            ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }